import React, { useEffect, useState } from 'react';
import { Sparkles, Plus } from 'lucide-react';
import { useAiChatStore } from '../../stores/aiChatStore';
import { useUIStore } from '../../stores/uiStore';

export const AiChatFloat: React.FC = () => {
  const { isOpen, toggleChat, messages } = useAiChatStore();
  const { openTaskModal } = useUIStore();
  const [showNotification, setShowNotification] = useState(false);
  const [lastMessageCount, setLastMessageCount] = useState(0);

  useEffect(() => {
    if (!isOpen && messages.length > 0) {
      const assistantMessages = messages.filter((m) => m.role === 'assistant');
      if (assistantMessages.length > lastMessageCount && lastMessageCount > 0) {
        setShowNotification(true);
      }
      setLastMessageCount(assistantMessages.length);
    }
    if (isOpen) {
      setShowNotification(false);
      const assistantMessages = messages.filter((m) => m.role === 'assistant');
      setLastMessageCount(assistantMessages.length);
    }
  }, [isOpen, messages, lastMessageCount]);

  useEffect(() => {
    if (isOpen) {
      setShowNotification(false);
    }
  }, [isOpen]);

  return (
    <>
      <button
        onClick={() => openTaskModal()}
        className={`
          fixed right-6 z-50
          w-12 h-12
          flex items-center justify-center
          rounded-full
          bg-gradient-to-br from-primary-500 to-primary-700
          hover:from-primary-600 hover:to-primary-800
          active:scale-95
          shadow-lg hover:shadow-xl
          transition-all duration-200
          focus:outline-none focus:ring-2 focus:ring-primary-400 focus:ring-offset-2 dark:focus:ring-offset-gray-900
          group
        `}
        style={{ bottom: 'calc(4.5rem + env(safe-area-inset-bottom))' }}
        aria-label="New Task"
      >
        <Plus
          className="w-5 h-5 text-white transition-transform duration-200 group-hover:scale-110"
        />
      </button>

      <button
        onClick={toggleChat}
        className={`
          fixed right-6 z-50
          w-10 h-10
          flex items-center justify-center
          rounded-full
          bg-gradient-to-br from-indigo-500 to-violet-600
          hover:from-indigo-600 hover:to-violet-700
          active:scale-95
          shadow-lg hover:shadow-xl
          transition-all duration-200
          focus:outline-none focus:ring-2 focus:ring-indigo-400 focus:ring-offset-2 dark:focus:ring-offset-gray-900
          group
        `}
        style={{ bottom: 'calc(1.5rem + env(safe-area-inset-bottom))' }}
        aria-label={isOpen ? 'Close AI Chat' : 'Open AI Chat'}
      >
        <Sparkles
          className={`w-4 h-4 text-white transition-transform duration-200 ${
            isOpen ? 'rotate-180' : 'group-hover:scale-110'
          }`}
        />
        {showNotification && (
          <span className="absolute top-1 right-1 w-3 h-3 bg-red-500 rounded-full ring-2 ring-white dark:ring-gray-900 animate-pulse" />
        )}
      </button>
    </>
  );
};

export default AiChatFloat;
